import { Configuration } from "shared/lib/v2/apis/programs";
import { ProgramService as ConvercusProgramService } from "shared/lib/v2/apis/programs/api/program.service";
import { HttpClient } from "@angular/common/http";
import { INTERACTION_ID } from "shared/lib/common/constants";
import { EnvironmentService } from "shared/lib/common/services";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../apis/programs/variables";
import * as i3 from "../../apis/programs/configuration";
import * as i4 from "../../../common/services/environment/environment.service";
export class ProgramService extends ConvercusProgramService {
    constructor(httpClient, basePath, configuration, environmentService) {
        super(httpClient, environmentService.getVariable("API_V2"), configuration);
        this.httpClient = httpClient;
        this.environmentService = environmentService;
    }
    getInteractionPointsOfProgram(programId, interactionId = INTERACTION_ID, recursive) {
        return super.getInteractionPointsOfProgram(interactionId, programId, recursive);
    }
    getStore(partnerId, programId, storeId, interactionId = INTERACTION_ID) {
        return super.getStore(interactionId, partnerId, programId, storeId);
    }
    getProgramConfig(programId) {
        if (programId === null || programId === undefined) {
            throw new Error("Required parameter programId was null or undefined when calling getProgramConfig.");
        }
        return this.httpClient.get(`${this.environmentService.getVariable("API_V2")}/public/programs/${programId}/config`, {
            headers: { "interaction-id": "posapp" },
        });
    }
}
ProgramService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProgramService_Factory() { return new ProgramService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BASE_PATH, 8), i0.ɵɵinject(i3.Configuration, 8), i0.ɵɵinject(i4.EnvironmentService)); }, token: ProgramService, providedIn: "root" });
